import type {PaginationMeta} from "../../../../redux/service/i-service";

export function buildPaginationMeta(
  page: number,
  perPage: number,
  total: number,
  hasNextPage: boolean
): PaginationMeta {
  const totalPages = Math.max(1, Math.ceil(total / perPage) || 1);
  return {
    current_page: page,
    per_page: perPage,
    total_pages: totalPages,
    next_page: hasNextPage ? page + 1 : 0,
    previous_page: page > 1 ? page - 1 : 0,
  };
}
